const { BASE_PATH } = require('../../../../lib/basePath.js');

function apiUrl(path) {
  const base = BASE_PATH === '/' ? '' : BASE_PATH;
  if (base && path.startsWith(BASE_PATH)) {
    return path;
  }
  return base + path;
}

module.exports = apiUrl;
